import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { COMPONENTS } from '.';
import { DialogComponent } from './dialog/dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoaderComponent } from './loader/loader.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';

export function playerFactory() {
	return player;
}

@NgModule({
	declarations: [COMPONENTS],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		MatDialogModule,
		MatButtonModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatAutocompleteModule,
		LottieModule.forRoot({ player: playerFactory }),
		NgxFileDropModule,
		MatTableModule,
		MatPaginatorModule,
		CdkScrollableModule,
		ScrollingModule
	],
	exports: [
		COMPONENTS,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatTableModule,
		MatPaginatorModule,
		CdkScrollableModule,
		ScrollingModule
	],
	entryComponents: [DialogComponent, LoaderComponent],
})
export class SharedModule {}
